import React, { useEffect } from "react";

import ModalResponse from "./ModalResponse";
import useValidateModalForm from "./hooks/useValidateModalForm";
import ModalForm from "~pages/ResearchManagement/Components/Modal/ModalForm";

const ValidateFormModal = ({ errors, isSubmiting, notification, onInvalid }) => {
  const { renderErrors, setValidationModalOpen, validationModalOpen } = useValidateModalForm(errors, isSubmiting, onInvalid);

  return (
    <>
      {notification ? (
        <>
          <ModalForm
            isOpen={validationModalOpen}
            onClose={() => setValidationModalOpen(false)}
            title={
              <>
                <p className="">
                  Há questões obrigatórias que <b className="text-[#ff0000]"> não foram preenchidas</b>. favor checar o
                  formulário
                </p>
              </>
            }
            status="alert"
          />
        </>
      ) : (
        <>
          <ModalResponse
            isOpen={validationModalOpen}
            status={"warning"}
            message={"Campos inválidos"}
            closeModal={() => setValidationModalOpen(false)}
            submessage={
              <>
                <p className="max-w-[300px] mx-auto">
                  Alguns campos precisam de sua atenção, revise o formulário e tente novamente
                </p>
                {renderErrors(errors)}
              </>
            }
          />
        </>
      )}
    </>
  );
};

export default ValidateFormModal;
